<!--Info-->
<div>
	<label style="font-weight: 500"
		>User <span>{{ Username }}</span> does not have an email on file. Please contact your CAASS Admin or contact
		<a href="https://www.access411.com/online-support/" target="_blank">Access 411 Support</a></label
	>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Ok</button>
</div>
